<template>
<div>
  <div class="home" v-if="pcShow">
    <headerTitle indexInit="3"/>
    <carouselPics :pics="pics" carouselIndex="1" carouselInx="1"/>
    <div class="block_div"></div>
    <titleBlock textChinese="服务优势" textEnglish="OURS  ADVANCED"/>
    <div class="block_div"></div>
    <serviceAdvancedText />
    <div class="block_div"></div>
    <!-- <div class="block_div"></div> -->
    <!-- <videoBlock :videoArray="videoArray" @selectPics="selectPics"/> -->
    <videoBlockSelect :videoArray="videoArraySelect"  @selectPics="selectPics"/>
    <!-- <div class="block_div"></div>
    <titleBlock textChinese="我们的优势" textEnglish="OURS  ADVANCED"/>
    <div class="block_div"></div>
    <serviceAdvanced /> -->
    
    <div class="block_div"></div>
    <serviceProgress />
    <div class="block_div"></div>
    <titleBlock textChinese="服务过的客户" textEnglish="COOPERATION PARTNERS"/>
    <div class="block_div"></div>
    <serviceClient />
    <div class="block_div"></div>
    <footerBlock />
     <videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag"/>

    <!-- <el-carousel class="wrap_pics">
      <el-carousel-item v-for="item in pics" :key="item">
        <h3 class="small">{{ item }}</h3>
        <img class="pics_each" :src="item.url"/>
      </el-carousel-item>
    </el-carousel> -->
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>  -->
  </div>
  <div v-if="!pcShow" class="wrap_mobile_bussvideo">
    <mobileHeader indexInit="3"/>
      <mobileCarousel :pics="images" carouselIndex="1" carouselInx="1"/>
      <mobileDivBlock />
      <!-- <mobileTitleBlock textChinese="服务项目" flagIndex="1" textEnglish="PROJECT  CLASSIFICATION" />
      <mobileDivBlock />
      <mobileServiceBlockBuss /> -->
      <mobileDivBlock />
      <mobileTitleBlock textChinese="服务优势" textEnglish="OURS  ADVANCED"/>
      <mobileDivBlock />
      <mobileDivBlock />
      <mobileserviceAdvancedText />
      <!-- <mobileTitleBlock textChinese="我们的服务" textEnglish="OURS SERVICES"/>
      <mobileDivBlock />
      <mobileourService />
      <mobileDivBlock />
      <mobileTitleBlock textChinese="服务花絮" textEnglish="SHOOTING GAGS"/>
      <mobileDivBlock />
      <mobileshooting /> -->
      <!-- <mobileDivBlock /> -->
      <mobilevideoBlockSelect :videoArray="videoArraySelect"  @selectPics="selectPics"/>
      <mobileprogress />
      <mobileDivBlock />
      <mobileTitleBlock textChinese="服务过的客户" textEnglish="COOPERATION PARTNERS" />
      <mobileDivBlock />
      <mobileserviceClient />
      <mobileDivBlock />
      <!-- <mobileDivBlock /> -->
      <mobilefooterBlock />
      <videoEachBlock @closeVideoFn="closeVideoFn" :videoUrl="videoUrl" v-if="videoFlag"/>

  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import carouselPics from '@/components/carouselPics.vue'
import headerTitle from '@/components/headerTitle.vue'
import titleBlock from '@/components/titleBlock.vue'
import serviceBlock from '@/components/serviceBlock.vue'
import videoBlock from '@/components/videoBlock.vue'
import videoBlockSelect from '@/components/videoBlockSelect.vue'
import serviceProgress from '@/components/serviceProgress.vue'
import serviceClient from '@/components/serviceClient.vue'
import footerBlock from '@/components/footerBlock.vue'
import serviceAdvanced from '@/components/serviceAdvanced.vue'
import serviceAdvancedText from '@/components/serviceAdvancedText.vue'
import videoEachBlock from '@/components/videoEachBlock.vue'
import mobileHeader from "@/components/mobileHeader.vue";
import mobileCarousel from "@/components/mobileCarousel.vue";
import mobileDivBlock from "@/components/mobileDivBlock.vue";
import mobileTitleBlock from "@/components/mobileTitleBlock.vue";
import mobileServiceBlockBuss from "@/components/mobileServiceBlockBuss.vue";
import mobileserviceAdvancedText from "@/components/mobileserviceAdvancedText.vue";
import mobileourService from "@/components/mobileourService.vue";
import mobileshooting from "@/components/mobileshooting.vue";
import mobileprogress from "@/components/mobileprogress.vue";
import mobilefooterBlock from "@/components/mobilefooterBlock.vue";
import mobilevideoBlockSelect from "@/components/mobilevideoBlockSelect.vue";
import mobileserviceClient from "@/components/mobileserviceClient.vue";






export default {
  name: 'shortvideo',
  data() {
    return {
      pics:[ 
        {url:require('@/assets/imgs/banner301.jpeg'),text:'<span style="font-size:54px;color:#fff">为优质品牌及公司提供专业的</span><span style="font-size:62px;color:#e91d62">影像定制解决方案</span>'},
        // {url:require('@/assets/imgs/banner02.jpeg'),text:'你好'},
        // {url:require('@/assets/imgs/banner03.jpeg'),text:'你好'},
        // {url:require('@/assets/imgs/banner04.jpeg'),text:'你好'} 
      ],
      videoUrl:{},
      videoFlag:false,
      videoArray:[
        [{url:require('@/assets/video/video201.jpeg'),text:'2020体彩广告-五大联赛篇',videoUrl:require('@/assets/video/video201.mp4')},
        {url:require('@/assets/video/video202.jpeg'),text:'2020体彩广告-图个乐篇',videoUrl:require('@/assets/video/video202.mp4')}],
        [{url:require('@/assets/video/video203.jpeg'),text:'2020体彩广告-去赛场篇',videoUrl:require('@/assets/video/video203.mp4')},
        {url:require('@/assets/video/video204.jpeg'),text:'微软mv《Open Windows》',videoUrl:require('@/assets/video/video204.mp4')}],
        [{url:require('@/assets/video/video205.jpeg'),text:'喜马拉雅vs腾讯视频双重会员TVC',videoUrl:require('@/assets/video/video205.mp4')},
        {url:require('@/assets/video/video206.jpeg'),text:'中部智谷片段',videoUrl:require('@/assets/video/video206.mp4')}],
      ],
      videoArraySelect:[
        // {url:require('@/assets/video/video201.jpeg'),text:'2020体彩广告-五大联赛篇',videoUrl:require('@/assets/video/video201.mp4')},
        // {url:require('@/assets/video/video202.jpeg'),text:'2020体彩广告-图个乐篇',videoUrl:require('@/assets/video/video202.mp4')},
        // {url:require('@/assets/video/video203.jpeg'),text:'2020体彩广告-去赛场篇',videoUrl:require('@/assets/video/video203.mp4')},
        {url:require('@/assets/video/video204.jpeg'),text:'微软mv《Open Windows》',videoUrl:require('@/assets/video/video204.mp4')},
        {url:require('@/assets/video/video205.jpeg'),text:'喜马拉雅vs腾讯视频双重会员TVC',videoUrl:require('@/assets/video/video205.mp4')},
        {url:require('@/assets/video/video206.jpeg'),text:'中部智谷片段',videoUrl:require('@/assets/video/video206.mp4')}
      ],
      pcShow: false,
      images: [
        {url:require('@/assets/imgs/banner301.jpeg'),text:'<span style="font-size:16px;color:#fff">为优质品牌及公司提供专业的</span><span style="font-size:16px;color:#e91d62">影像定制解决方案</span>'},
      ],
    }
  },
  components: {
    carouselPics,
    headerTitle,
    titleBlock,
    serviceBlock,
    videoBlock,
    serviceProgress,
    serviceClient,
    footerBlock,
    serviceAdvanced,
    serviceAdvancedText,
    videoEachBlock,
    videoBlockSelect,
    mobileHeader,
    mobileCarousel,
    mobileDivBlock,
    mobileTitleBlock,
    mobileServiceBlockBuss,
    mobileserviceAdvancedText,
    mobileourService,
    mobileshooting,
    mobileprogress,
    mobilefooterBlock,
    mobilevideoBlockSelect,
    mobileserviceClient
  },
  methods:{
    widthChange() {
      console.log(123333);
      let clientWidthW = document.body.clientWidth;
      console.log(this.pcShow, "999000this.pcShow");
      console.log(clientWidthW, "9900");
      if (clientWidthW < 768) {
        this.pcShow = false;
      } else {
        this.pcShow = true;
      }
    },
    closeVideoFn(){
      this.videoFlag = false
    },
    selectPics(index,inx){
      this.videoFlag = true
      this.videoUrl.videoUrl = this.videoArraySelect[index].videoUrl
      console.log(this.videoUrl,'this.videoUrl')
    }
  },
  mounted() {
    this.widthChange();
    window.addEventListener("resize", this.widthChange);
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
}
</script>
<style lang="less">

 .wrap_mobile_bussvideo{
  div{
    overflow: hidden;
  }
}
</style>
